module.exports = __webpack_public_path__ + "media/images/PackageIcon-01-0ea23ddc.png";